<template>
    <BreadCrumb PageTitle="Liste des affectations" />
    <ListeAffectation />
</template>

<script lang="ts">

import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ListeAffectation from "@/components/Affectation/ListeAffectation.vue";


export default defineComponent({
    name: "ListeAffectationPage",
    components: {
        BreadCrumb,
        ListeAffectation,
    },
});
</script>